<template>
  <el-row :gutter="50">
    <el-col :span="14">
      <unavailable-datatable :loading="loading"></unavailable-datatable>
    </el-col>
    <el-col :span="10">
      <unavailable-form
          ref="formRef"
      >
        <template #default="{fields, form, reset}">
         <el-form-item>
           <el-button
               :loading="loading"
               type="success"
               @click="submit"
           >
             新增
           </el-button>
         </el-form-item>
        </template>
      </unavailable-form>
    </el-col>
  </el-row>
</template>

<script>
import {mapActions} from 'vuex';
import UnavailableMixin from './UnavailableMixin';
import UnavailableDatatable from './UnavailableDatatable';
import UnavailableForm from './UnavailableForm';

export default {
  name: 'UnavailableManage',
  components: {
    UnavailableDatatable,
    UnavailableForm
  },
  mixins: [UnavailableMixin],
  methods: {
    ...mapActions('unavailable', {
      insertUnavailableRange: 'insertUnavailableRangeAction',
    }),

    async submit() {
      const {getFields, getRef, reset} = this.$refs.formRef;
      const formRef = getRef();
      const form = getFields();
      await formRef.validate(async (valid) => {
        if (valid) {
          const {schoolYear, semester, vacancies} = this;
          const ncutRoomIds = vacancies
              .filter(v => form.roomIds.some(r => r === v.id));
          const unavailables = ncutRoomIds
              .map(r => ({
                roomId: r.ncutRoomId,
                beginDate: form.range[0],
                endDate: form.range[1],
                periodBegin: form.periods[0],
                periodEnd: form.periods[1],
                weekdays: [...form.weekdays],
                schoolYear,
                semester,
                sameAsSemesterRange: form.sameAsSemesterRange,
                who: `${this.name}`,
                reason: form.reason

              }));
          const {success, messages = []} = await this.insertUnavailableRange(unavailables);
          if (success) {
            this.$message.success('新增成功');
            if (reset && typeof reset === 'function') {
              reset();
            }
          } else {
            this.$message.warning(messages.join(','));
          }
        } else {
          this.$message({
            type: 'warning',
            message: '您還有欄位尚未輸入!!'
          });
        }
      });
    },
  },

}
</script>

<style scoped>

</style>